// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__7a9IX","header":"PriceList_header__XtgZJ"};